import { Box, Button, DropdownMenu } from '@betterment/samba-react';

import { AddCashOptions } from './AddCashOptions';

import { trackClick } from '../../../../features/track';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import {
  OtherTransactionOptions,
  TransactionOptionsProps,
} from '../../../../Shared/components/transaction-buttons/TransactionButtons';
import { EnvelopeAccountTransactionOptionsQuery } from '../graphql/envelopeAccountTransactionOptions.generated';

type DirectTradingAccount = NarrowTypename<EnvelopeAccountTransactionOptionsQuery['account'], 'DirectTradingAccount'>;

type Props = TransactionOptionsProps & {
  account: DirectTradingAccount;
};

export const ManageCashButton: React.FC<Props> = ({ account, transactionOptions, subAccounts }) => {
  const { totalBalance } = account.cashBalances;

  const hasBalance = (totalBalance?.cents ?? 0) > 0;
  const buttonLabel = hasBalance ? 'Manage' : 'Add cash';

  return (
    <Box>
      <DropdownMenu>
        <DropdownMenu.Trigger asChild={true}>
          <Button
            variant="textPrimary"
            onClick={() => {
              trackClick({ name: 'ManageCash' });
            }}
          >
            {buttonLabel}
          </Button>
        </DropdownMenu.Trigger>

        <DropdownMenu.Content align="end" side="bottom">
          <AddCashOptions account={account} />
          {hasBalance && (
            <OtherTransactionOptions
              transactionOptions={transactionOptions}
              subAccounts={subAccounts}
              isCompact={true}
            />
          )}
        </DropdownMenu.Content>
      </DropdownMenu>
    </Box>
  );
};
